// extracted by mini-css-extract-plugin
export var fullHeightState = "_1g-7";
export var headerCell = "_1g-1";
export var loadingStateCell = "_1g-4";
export var rowWrapper = "_1g-3";
export var standaloneTable = "_1g-8";
export var standaloneTableWithBodyFill = "_1g-9";
export var stateCell = "_1g-5";
export var table = "_1g-0";
export var tableBodyFiller = "_1g-6";
export var white = "_1g-2";